import { render, staticRenderFns } from "./resultImproveManage.vue?vue&type=template&id=36bc6911"
import script from "./resultImproveManage.vue?vue&type=script&lang=js"
export * from "./resultImproveManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36bc6911')) {
      api.createRecord('36bc6911', component.options)
    } else {
      api.reload('36bc6911', component.options)
    }
    module.hot.accept("./resultImproveManage.vue?vue&type=template&id=36bc6911", function () {
      api.rerender('36bc6911', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/gci/rim/resultImproveManage.vue"
export default component.exports